'use strict';

import React from 'react';

import FormField from './FormField';
import Logger from '../../utils/Logger';

const { id: module_id } = module;
const logger = Logger(module_id);

class FieldGroup extends React.Component {
  constructor(props) {
    super(props);
    if (this.props.handleValueChange) {
      this.handleValueChange = props.handleValueChange.bind(this);
    }
  }

  render() {
    const divider = this.props.data.divide ? <hr /> : null;
    const repeatable = this.props.data.repeatable;
    let className = this.props.data.className
      ? this.props.data.className
      : 'row-fluid';
    let existingValues = this.props.values;

    return (
      <div className={className}>
        {divider}
        {repeatable && existingValues instanceof Array
          ? existingValues.map((existingValue, index) => {
              return (
                <div
                  className="row-fluid"
                  style={{ fontWeight: 1000 }}
                  key={index}
                >
                  {Object.keys(existingValue)
                    .sort((a, b) => {
                      return (
                        this.props.data.fields.filter(
                          (field) => field.name === b
                        )[0].key >
                        this.props.data.fields.filter(
                          (field) => field.name === a
                        )[0].key
                      );
                    })
                    .map((val) => (
                      <FormField
                        key={val}
                        val={
                          this.props.data.fields.filter(
                            (field) => field.name === val
                          )[0]
                        }
                        existingVal={existingValue[val]}
                        handleValueChange={this.props.handleValueChange}
                      />
                    ))}
                </div>
              );
            })
          : this.props.data.fields.map((val) => (
              <FormField
                key={val.key}
                val={val}
                existingVal={existingValues && existingValues[val.name]}
                handleValueChange={this.props.handleValueChange}
              />
            ))}
      </div>
    );
  }
}

export default FieldGroup;
